import React from 'react';
import './BoardTechnicianColumnsSkeleton.css';

const SLOT_KEYS = ['a', 'b', 'c'];

export function BoardTechnicianColumnsSkeleton() {
  return (
    <div className="board-tech-cols-skeleton" aria-busy="true" aria-label="Carregando colunas de técnicos">
      {SLOT_KEYS.map((key) => (
        <div key={key} className="board-tech-cols-skeleton-col">
          <div className="board-tech-cols-skeleton-header">
            <span className="board-tech-cols-skeleton-bar board-tech-cols-skeleton-bar--title" />
            <span className="board-tech-cols-skeleton-bar board-tech-cols-skeleton-bar--chip" />
          </div>
          <div className="board-tech-cols-skeleton-body">
            <span className="board-tech-cols-skeleton-bar board-tech-cols-skeleton-bar--line" />
            <span className="board-tech-cols-skeleton-bar board-tech-cols-skeleton-bar--line board-tech-cols-skeleton-bar--short" />
            <span className="board-tech-cols-skeleton-bar board-tech-cols-skeleton-bar--line" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default BoardTechnicianColumnsSkeleton;
